        var acc = document.getElementsByClassName("pure-posture-faq-accordion");
        

        for (var i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }

// Show Hide Function
        function showhide() {
            var y = document.getElementById("changebtntext");
            if ( y.innerHTML === "Show All FAQ's" ) {
              	  y.innerHTML = "Show Less FAQ's";
                } else {
                  y.innerHTML = "Show All FAQ's";
                }

            }

			  $(document).ready(function(){
  				$('.faqmorebtn').click(function(){
   				$('.ctm-hide-section').toggle(400);
  				});
  				});
